import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import merge from './merge';
import PopupManager from './popupManager';

let idSeed = 1;
const transitions: string[] = [];

const hookTransition = (transition: string) => {
    if (transitions.indexOf(transition) !== -1) {
        return;
    }

    // @ts-ignore
    const getVueInstance = (element) => {
        let instance = element.__vue__;
        if (!instance) {
            const textNode = element.previousSibling;
            if (textNode.__vue__) {
                instance = textNode.__vue__;
            }
        }
        return instance;
    };

    // 这个是什么函数
    // @ts-ignore
    Vue.transition(transition, {
        // @ts-ignore
        afterEnter(el) {
            const instance = getVueInstance(el);
            if (instance && instance.doAfterOpen) {
                instance.doAfterOpen();
            }
        },
        // @ts-ignore
        afterLeave(el) {
            const instance = getVueInstance(el);
            if (instance && instance.doAfterClose) {
                instance.doAfterClose();
            }
        },
    });
};

// @ts-ignore
let scrollBarWidth;
const getScrollBarWidth = () => {
    if (Vue.prototype.$isServer) {
        return;
    }
    // @ts-ignore
    if (scrollBarWidth !== undefined) {
        // @ts-ignore
        return scrollBarWidth;
    }

    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode!.removeChild(outer);

    return widthNoScroll - widthWithScroll;
};

const getDOM = (dom: HTMLElement) => {
    if (dom.nodeType === 3) {
        // @ts-ignore
        dom = dom.nextElementSibling || dom.nextSibling;
        getDOM(dom);
    }
    return dom;
};

@Component({})
export default class Popup extends Vue {
    @Prop({ type: Boolean, default: false }) public value!: boolean;
    // 在MessageBox中可能并没有使用
    @Prop({ type: String, default: '' }) public transition!: string;
    @Prop({}) public openDelay!: any;
    @Prop({}) public closeDelay: any;
    @Prop({}) public zIndex!: number;
    @Prop({ type: Boolean, default: false }) public modal!: boolean;
    @Prop({ type: Boolean, default: true }) public modalFade!: boolean;
    @Prop({}) public modalClass: any;
    @Prop({ type: Boolean, default: true }) public lockScroll!: boolean;
    @Prop({ type: Boolean, default: false }) public closeOnPressEscape!: boolean;
    @Prop({ type: Boolean, default: false }) public closeOnClickModal!: boolean;

    public _popupId: any;
    public _opening: any;
    public _closing: any;
    public _openTimer: any;
    public _closeTimer: any;
    public closeTimer: any;
    public willOpen: any;
    public onOpen?: any;
    public willClose: any;
    public onClose?: () => void;
    public visible: boolean = false;
    public opened: boolean = false;
    public bodyOverflow = null;
    public bodyPaddingRight = null;
    public rendered: boolean = false;

    @Watch('value')
    public onPopupValueChange(val: boolean) {
        if (val) {
            if (this._opening) {
                return;
            }
            if (!this.rendered) {
                this.rendered = true;
                Vue.nextTick(() => {
                    this.open();
                });
            } else {
                this.open();
            }
        } else {
            this.close();
        }
    }

    public open(options?: any) {
        if (!this.rendered) {
            this.rendered = true;
            this.$emit('input', true);
        }

        const props = merge({}, this, options, this.$props);

        if (this._closeTimer) {
            clearTimeout(this._closeTimer);
            this._closeTimer = null;
        }
        clearTimeout(this._openTimer);

        const openDelay = Number(props.openDelay);
        if (openDelay > 0) {
            this._openTimer = setTimeout(() => {
            this._openTimer = null;
            this.doOpen(props);
            }, openDelay);
        } else {
            this.doOpen(props);
        }
    }

    public doOpen(props: any) {
        if (this.$isServer) {
            return;
        }
        if (this.willOpen && !this.willOpen()) {
            return;
        }
        if (this.opened) {
            return;
        }

        this._opening = true;

        // 使用 vue-popup 的组件，如果需要和父组件通信显示的状态，应该使用 value，它是一个 prop，
        // 这样在父组件中用 v-model 即可；否则可以使用 visible，它是一个 data
        this.visible = true;
        this.$emit('input', true);

        // @ts-ignore
        const dom = getDOM(this.$el);

        const modal = props.modal;

        const zIndex = props.zIndex;
        if (zIndex) {
            PopupManager.zIndex = zIndex;
        }

        if (modal) {
            if (this._closing) {
                PopupManager.closeModal(this._popupId);
                this._closing = false;
            }
            PopupManager.openModal(this._popupId, PopupManager.nextZIndex(), dom, props.modalClass, props.modalFade);
            if (props.lockScroll) {
                if (!this.bodyOverflow) {
                    // @ts-ignore
                    this.bodyPaddingRight = document.body.style.paddingRight;
                    // @ts-ignore
                    this.bodyOverflow = document.body.style.overflow;
                }
                scrollBarWidth = getScrollBarWidth();
                // @ts-ignore
                const bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
                if (scrollBarWidth > 0 && bodyHasOverflow) {
                    document.body.style.paddingRight = scrollBarWidth + 'px';
                }
                document.body.style.overflow = 'hidden';
            }
        }

        if (getComputedStyle(dom).position === 'static') {
            dom.style.position = 'absolute';
        }

        dom.style.zIndex = String(PopupManager.nextZIndex());
        this.opened = true;

        if (this.onOpen ) {
            this.onOpen();
        }

        if (!this.transition) {
            this.doAfterOpen();
        }
    }

    public doAfterOpen() {
        this._opening = false;
    }

    public close() {
        if (this.willClose && !this.willClose()) {
            return;
        }

        if (this._openTimer !== null) {
            clearTimeout(this._openTimer);
            this._openTimer = null;
        }
        clearTimeout(this._closeTimer);

        const closeDelay = Number(this.closeDelay);

        if (closeDelay > 0) {
            this._closeTimer = setTimeout(() => {
            this._closeTimer = null;
            this.doClose();
            }, closeDelay);
        } else {
            this.doClose();
        }
    }

    public doClose() {
        this.visible = false;
        this.$emit('input', false);
        this._closing = true;

        if (this.onClose) {
            this.onClose();
        }

        if (this.lockScroll) {
            setTimeout(() => {
            if (this.modal && this.bodyOverflow !== 'hidden') {
                document.body.style.overflow = this.bodyOverflow!;
                document.body.style.paddingRight = this.bodyPaddingRight!;
            }
            this.bodyOverflow = null;
            this.bodyPaddingRight = null;
            }, 200);
        }

        this.opened = false;

        if (!this.transition) {
            this.doAfterClose();
        }
    }

    public doAfterClose() {
        PopupManager.closeModal(this._popupId);
        this._closing = false;
    }

    public created() {
        if (this.transition) {
            hookTransition(this.transition);
        }
    }

    public beforeMount() {
        this._popupId = 'popup-' + idSeed++;
        PopupManager.register(this._popupId, this);
    }

    public beforeDestroy() {
        PopupManager.deregister(this._popupId);
        PopupManager.closeModal(this._popupId);
        if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
        document.body.style.overflow = this.bodyOverflow!;
        document.body.style.paddingRight = this.bodyPaddingRight!;
        }
        this.bodyOverflow = null;
        this.bodyPaddingRight = null;
    }
}

export { PopupManager };
